'use client';

import { useIntl } from 'react-intl';
import { InstallmentValueTile } from '../InstallmentValueTile/InstallmentValueTile.client';

export interface InstallmentValueTilesContainerProps {
  /**
   * a list of installments (actually viableInstallments in data)
   */
  installmentsList: number[];
  /**
   * the active installment (actually numberOfInstallments in data)
   */
  activeInstallment: number;
  /**
   * on click handler function
   */
  installmentSelectedHandler: (value: number) => void;
}

/**
 * installment value container atom
 *
 * a wrapper for InstallmentValueTile atoms
 *
 * */
export const InstallmentValueTilesContainer = ({
  installmentsList,
  activeInstallment,
  installmentSelectedHandler,
}: InstallmentValueTilesContainerProps) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <p className="text-size-body1 mb-0.5">
        {formatMessage({
          id: 'ic-atom-InstallmentValueTilesContainer-headline',
          defaultMessage: 'Wähle die gewünschten Raten',
        })}
      </p>
      <div className="flex flex-row flex-wrap gap-1">
        {installmentsList.map((installmentValue) => (
          <InstallmentValueTile
            value={installmentValue}
            active={installmentValue === activeInstallment}
            onClickHandler={installmentSelectedHandler}
            key={installmentValue}
          />
        ))}
      </div>
    </div>
  );
};
